import React from "react";

const Message = ({ message, color = "success", mb = 4 }) => {
  return (
    <React.Fragment>
      <div className={`mb-${mb} w-100`}>
        <span
          className={`badge bg-${color} p-2 fs-12 text-uppercase w-100`}
          style={{
            lineHeight: "1rem",
            whiteSpace: "normal",
          }}
        >
          {message}
        </span>
      </div>
    </React.Fragment>
  );
};

export default Message;
